// GENERATED by scripts/build-catalog.mjs from data/project.yaml — do not edit.
//
// The localStorage namespace, and any keys this project used before.
// Renaming a project must not orphan a user's watched progress: the read path
// in src/state/persistedState.ts migrates the first legacy key it finds.

export const PROJECT_STORAGE_KEY = "katchup-paw:state";

export const PROJECT_LEGACY_STORAGE_KEYS: readonly string[] = [];
